
define(
	'C3.ShoppingExtensions.IncomingEquipment'
,   [
	//	'C3.ShoppingExtensions.IncomingEquipment.MainView',
		'C3.ShoppingExtensions.IncomingEquipment.Router',
		'C3.ShoppingExtensions.IncomingEquipment.Collection',
		'C3.ShoppingExtensions.IncomingEquipment.HomeView'
	]
,   function (
	//	IncomingEquipmentMainView,
		Router,
		IncomingEquipmentCollection,
		HomeIncomingEquipment
		
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var environment = container.getComponent("Environment");
			var layout = container.getComponent('Layout');
			var pageType = container.getComponent('PageType');

			if(layout && environment)
			{
				var collection = new IncomingEquipmentCollection()

				layout.addChildView('Incoming-Equipment-DataFeed', function(){
					return new HomeIncomingEquipment({
						application: container,
						collection : collection
					});
				})


				/*var ieRoutes = [
		            'incoming-equipment',
		            'incoming-equipment?:options'
		        ];

				var incomingEquipmentMainPage = 	{
				        name: 'incoming-equipment',
			            routes: ieRoutes,
			            application: layout.application,
			            view: IncomingEquipmentMainView,
			            options: {collection: collection,application :layout.application},
				   }

				pageType.registerPageType(incomingEquipmentMainPage); */

				return new Router(container);  
			}
		}
	};
});
